import React from "react";
import { Gift } from "lucide-react";

export default function PromoCard() {
  return (
    <div className="stb-card p-4 relative overflow-hidden" data-testid="promo-card">
      <span className="stb-rivet" style={{ top: 4, left: 4 }} />
      <span className="stb-rivet" style={{ top: 4, right: 4 }} />
      <span className="stb-stripes block h-2 mb-3 w-20" />
      <h3 className="stb-h text-lg text-white leading-tight inline-flex items-center gap-2">
        <Gift size={22} className="text-[#FF6B00] stb-glow-orange" /> Topni a vyhraj 🍺
      </h3>
      <div className="mt-3 rounded-sm overflow-hidden border border-[#262626] bg-white flex items-center justify-center">
        <img
          src="/promo-pivo.webp"
          alt="Dárek – 6× pivo v plechu"
          className="w-full h-auto object-contain max-h-44"
          data-testid="promo-card-image"
        />
      </div>
      <p className="text-sm text-[#A3A3A3] mt-3 leading-relaxed">
        Každé <strong className="text-white">100. TOPnutí</strong> inzerátu na STAVBOŠ vyhrává
        dárek <strong className="text-white">6× pivo v plechu</strong>. Výherce kontaktujeme
        e-mailem a dárek pošleme přes Zásilkovnu. Topni svůj inzerát — můžeš to být právě ty!
      </p>
    </div>
  );
}
